(function($){
  $(document).ready(function(){

    // SUB MENU NAVIGATION STYLE
    $('.mobile_menu').click(function(e){
      e.preventDefault();
      $('.header-mobile-nav').show();
      $('.header-mobile-nav-container').addClass("open");

      $('.content-overlay').show();
    });

    $('.content-overlay').click(function(){
      $('.content-overlay').hide();
      $('.header-mobile-nav').hide();
      $('.mobile-sub-nav').removeClass('sub-nav-open');

    });
    
    

    // SUB NAV OPEN
    $('.header-mobile-nav-ul > li.header-mobile-nav-li > a').click(function(e) {
      if ($(window).width() < 854) {
        var $this = $(this);
        var $parent = $this.parent();
        if($this.siblings('.mobile-sub-nav')){
          e.preventDefault()
        }
        // e.preventDefault();
        $parent.children('.mobile-sub-nav').addClass("sub-nav-open").removeClass("sub-nav-close");
      }
    });
    // SUBNAV CLOSE
    $('.sub-nav-back').click(function(e){
      e.preventDefault();
      $('.mobile-sub-nav').removeClass("sub-nav-open").addClass("sub-nav-close");
    });

    //MODAL OVERLAY HOMEPAGE CLOSE
    $('.close-popup').click(function(e){
      $('.modal-popup').hide();
    });
    $('.close-popup-mobile').click(function(e){
      $('.modal-popup').hide();
    });
    


    // 	HOMEPAGE SLIDER
    $('.rslides').slick({
      dots: false ,
      infinite: true,
      speed: 300,
      arrow: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: $('.homepage-slider-prev'),
      nextArrow: $('.homepage-slider-next'),
      varWidth: true,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
//     MAIL CHIMP
    
    $('.unique-chimp-redirect1, #unique-mailchimp-s').submit(function(e){
      e.preventDefault();
      var $this = $(this),
          emailText = $this.find('.newsletter-input, .homeemail'),
          mailChimp = $('#mc_embed_signup'),
          mailInput = mailChimp.find('#mce-EMAIL'),
          mailForm = mailChimp.find('#mc-embedded-subscribe-form'),
          mailCheck = 
          testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;


      if(testEmail.test(emailText.val())){
        mailInput.val(emailText.val());
        mailForm.submit();
      } 

      else {
        e.preventDefault(); 
      }

    });
    
    $('.newsletter-popup-form').submit(function(e){
      var mailChimp = $('#mc_embed_signup'),
          mailForm = mailChimp.find('#mc-embedded-subscribe-form');
    });
 


	// HOMEPAGE INSTAGRAM FEED

    var instaFeed = new Instafeed({
      get: 'user',
      userId: '3151001942',
      resolution: 'standard_resolution',
      accessToken: '3151001942.1677ed0.eb32fd320e714325a6a20515e56280d3',
      sortBy: 'most-recent',
      template: '<li><a href="\{\{link\}\}" target="_blank"><img src="\{\{image\}\}" alt=""></a></li>',
      after: function() {
        $('.socialmedia-slides').slick({
          dots: false ,
          infinite: true,
          speed: 300,
          arrow: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: $('.fs-slider-prev-button'),
          nextArrow: $('.fs-slider-next-button'),
          varWidth: true,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        }); 
      }
    });
    

    // INSTAGRAM FEED HOMEPAGE
    if($('body').hasClass('template-index')){
      instaFeed.run();
    };
    
    
//     PRODUCT INSTAGRAM FEED
    var feed = new Instafeed({
      get: 'user',
      userId: '3151001942',
      resolution: 'standard_resolution',
      accessToken: '3151001942.1677ed0.eb32fd320e714325a6a20515e56280d3',
      sortBy: 'most-recent',
      target: 'instafeed2',
      template: '<li><a href="\{\{link\}\}" target="_blank"><img src="\{\{image\}\}" alt=""></a></li>',
      after: function() {
        $('.product-socialmedia-slides').slick({
          dots: false ,
          infinite: true,
          speed: 300,
          arrow: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: $('.product-fs-slider-prev-button'),
          nextArrow: $('.product-fs-slider-next-button'),
          varWidth: true,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        }); 
      }
    });
      feed.run();
    
    
    // PRODUCT SLIDER
    $('.isp_related-slick-list').slick({
      dots: false ,
      infinite: true,
      speed: 300,
      arrow: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $('.isp-fs-slider-prev-button'),
      nextArrow: $('.isp-fs-slider-next-button'),
      varWidth: true,

      responsive: [
        { 
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    
//     PRODUCT SLIDER THUMBNAIL
    if ($(window).width() < 768 ) {
      $('.thumbnails-swap').slick({
        dots: false ,
        infinite: true,
        speed: 300,
        arrow: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.btn-t-slider-prev'),
        nextArrow: $('.btn-t-slider-next'),
        varWidth: true,
      });
    };
    
    
// 	IMAGE ON HOVER ELEVATE ZOOM
    
    var $zoom = $('#zoom_01');
    if ($(window).width() > 480 ){
    $zoom.elevateZoom({
      cursor:"pointer",
      zoomType: "inner"
    });
    };
    $('.thumbpreview').click(function(e){
      e.preventDefault();
      $('.changeimg').attr('src',this.src);
      if ($(window).width() > 480 ){
      $zoom.data('zoom-image',this.src).elevateZoom({
        cursor:"pointer",
        zoomType: "inner"
      });
      };
    });
    
    
    
    // BEGIN SHOW ALL
    var showAllProducts = false;
    if( $('body').hasClass('template-collection') || $('body').hasClass('template-collection') ){
      $('#show-all-button').click(function(e){
        showAllProducts = true;
        $('#bc-sf-filter-load-more').css('opacity',0);
      });

      window.addEventListener('scroll', throttle(throttlecb, 1000));

      function throttle(fn, wait) {
        var time = Date.now();
        return function() {
          if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
          }
        }
      }

      var simulateClick = function (elem) {
        // Create our event (with options)
        var evt = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        // If cancelled, don't dispatch our event
        var canceled = !elem.dispatchEvent(evt);
      };



      function throttlecb() {
        var someLink = document.getElementById('show-more-button');
        if(showAllProducts) {
          simulateClick(someLink);
        }
      }
    }  
    // END OF SHOW ALL

//     PRODUCT RIGHT SIDE CONTENT SLIDEUP AND SLIDE DOWN

//     $('.psd-header-details').addClass('psd-open');
//     $('.psd-header-sizefit').addClass('psd-close');
//     $('.psd-header-shipping').addClass('psd-close');

    
//     $('.psd-header-details').click(function(e){
//       if ($('.psd-header-details').hasClass('psd-close')){
//       $('.psd-header-details').removeClass('psd-close').addClass('psd-open');
//       $('.psd-header-sizefit').removeClass('psd-open').addClass('psd-close');
//       $('.psd-header-shipping').removeClass('psd-open').addClass('psd-close');

//       $('.psd-header-details-content').slideDown();
//       $('.psd-header-sizefit-content').slideUp();
//       $('.psd-header-shipping-content').slideUp();
//       }
//     });

//     $('.psd-header-sizefit').click(function(e){
//       $('.psd-header-sizefit').removeClass('psd-close').addClass('psd-open');
//       $('.psd-header-details').removeClass('psd-open').addClass('psd-close');
//       $('.psd-header-shipping').removeClass('psd-open').addClass('psd-close');

//       $('.psd-header-sizefit-content').slideDown();	
//       $('.psd-header-details-content').slideUp();
//       $('.psd-header-shipping-content').slideUp();
//     });

//     $('.psd-header-shipping').click(function(e){
//       $('.psd-header-shipping').removeClass('psd-close').addClass('psd-open');
//       $('.psd-header-details').removeClass('psd-open').addClass('psd-close');
//       $('.psd-header-sizefit').removeClass('psd-open').addClass('psd-close');

//       $('.psd-header-shipping-content').slideDown();
//       $('.psd-header-details-content').slideUp();
//       $('.psd-header-sizefit-content').slideUp();
//     });
    
    $('.psd-header-details').addClass('psd-close');
    $('.psd-header-sizefit').addClass('psd-close');
    $('.psd-header-shipping').addClass('psd-close');

    
    $('.psd-header-details').click(function(e){
      $('.psd-header-details').toggleClass('psd-close').toggleClass('psd-open');
      $('.psd-header-details-content').slideToggle();
    });

    $('.psd-header-sizefit').click(function(e){
      $('.psd-header-sizefit').toggleClass('psd-close').toggleClass('psd-open');
      $('.psd-header-sizefit-content').slideToggle();	
    });

    $('.psd-header-shipping').click(function(e){
      $('.psd-header-shipping').toggleClass('psd-close').toggleClass('psd-open');
      $('.psd-header-shipping-content').slideToggle();
    });
    
    
    // ajax add to cart
    $('.product-form__item--submit').click(function(e){
      e.preventDefault();

      var $form = $(this).closest('form');
      var $quantity = $form.find('.cart-quantity').val();
      var $id = $form.find('button[name="id"]').val();

      $.ajax({
        method: 'POST',
        url: '/cart/add',
        data: {
          quantity: $quantity,
          id: $id
        },
        success: function(data){
          var $cartData = $('<div>'+data+'</div>');
          var qty = $cartData.find('.basket-qty').text();
          var $basketcount = $('.basket-qty');
          var basketEmpty = 0;
          var $cartData1 = $('<div>'+data+'</div>');
          var qty1 = $cartData1.find('.basket-qty1').text();
          var $basketcount1 = $('.basket-qty1');
          
         
     
          if ($(window).width() > 854) {
            if($basketcount.length){
              $basketcount.text(qty);
            } else {
              $('.card_sec > a').append('<span class="basket-qty">'+qty+'</span>');
              $('.basket-empty').hide();

            }
             
          }
          else {
            if($basketcount1.length){
              $basketcount1.text(qty1);
            } else {
              $('.mobile-header-container > a.cart-count').append('<span class="basket-qty1">'+qty1+'</span>');
              $('.basket-empty').hide();

            }
            
          }
          $(".mini-shopping-cart").load(" .mini-shopping-cart > *");
          $('.ajaxified-cart-feedback').fadeIn();
  		
          
        },
        error: function(data){
    
		
           $('.fancybox-overlay').show();

          
          $('.atc-span').contents().filter(function(){ return this.nodeType == 3; }).remove();
          $('.atc-span').append("SOLD OUT");
          $('.ajaxified-cart-feedback').fadeOut();
               
        }
        
         
      });
	
    });
    
//     ERROR MESSAGE OVERLAY CLOSE
    
    $('.fancybox-overlay').click(function(e){
    	$('.fancybox-overlay').hide();
    })
    

    $('.mc-close').click(function(e){
      e.preventDefault();
      $('.mini-shopping-cart').hide();
    });
    
    
//     EDIT OVERLAY CLOSE
    $('.cls_popup').click(function(e){
      e.preventDefault();
      $('.editItemContainer').hide();
    });
    
//     EDIT OVERLAY OPEN
//     $('.cart__remove-edit').click(function(e){
//       e.preventDefault();
//  		$('.mini-shopping-cart').hide();
//       	$('.editItemContainer').show();
//     });
   
    
//     SHOW MINI CART ON HOVER
    
    $('.mini-shopping-cart').addClass("close-overlay")

    $(".card_sec").hover(function(){
	 
      if($('.mini-shopping-cart').hasClass("close-overlay")){
        $('.mini-shopping-cart').fadeIn();
        $(".card_sec").hover(function(){
          $('.mini-shopping-cart').removeClass("close-overlay");
          $('.mini-shopping-cart').addClass("open-overlay");
        });

      } else if($('.mini-shopping-cart').hasClass("open-overlay")){
        $('.mini-shopping-cart').fadeOut();
        $(".card_sec").hover(function(){
          $('.mini-shopping-cart').removeClass("open-overlay");
          $('.mini-shopping-cart').addClass("close-overlay");
        });

      }

    });
    
    
//     CART PAGE INCREMENT AND DECREMENT

      // Quantity Selector
    
//       var $quantitySelect = $('.cart__qty');
//       $quantitySelect.each(function(){
//         var $el = $(this);
//         var $quantityDown = $el.find('.button-minus-btn');
//         var $quantityUp = $el.find('.button-plus-btn');
//         var $quantity = $el.find('.cart__qty-input');
//         var quantity = $quantity.val();

//         $quantityDown.on('click', function(e){
//           quantity = $quantity.val();
//           if(quantity > 1){
//             quantity--;
//             $quantity.val(quantity);
//           }
//           e.preventDefault();
//           $(this).closest('form').submit();
// //            $el.find('.cart_quantity_button').find('.update-action').trigger('click');
          
//         });

//         $quantityUp.on('click', function(e){
//           quantity = $quantity.val();
//           quantity++;
//           $quantity.val(quantity);

//           e.preventDefault();
//           $(this).closest('form').submit();
// //           $el.find('.update-action').trigger('click');
          
//         });
//       });
    
     $('.quantity-selector').change(function(e){
        var $this = $(this),
            $value = $this.children("option:selected").val(),
            $qtyData = $this.closest('.cart__qty').find('.cart__qty-input'),
       		$onlyStock = $this.closest('.cart__qty').find('.item-variant-inventory').val();
			
            $qtyData.val($value);
       
       
       if(  $value > $onlyStock){
         $('.fancybox-overlay').show();
          e.target.selectedIndex = 0;
       } else{
         $this.siblings('.update-action').trigger('click');
       }
      });
    
    
    $('#fpassword').click(function(e){
      e.preventDefault();
      $('#CustomerLoginForm').hide();
      $('#RecoverPasswordForm').show();

    });
    
    
    $('#create_customer').submit(function(e) {
      var $this = $(this),
          email = $this.find('#Email'),
          email2 = $this.find('#confirm_email'),
          password = $this.find('#CreatePassword'),
          password2 = $this.find('#confirm_password');
     
      if (email.val() != email2.val()) {
        $('.reg-error-email').fadeIn();
         e.preventDefault();
      }
      else if(password.val() != password2.val()){
      	$('.reg-error-pass').fadeIn();
         e.preventDefault();
      } else{
      $('#create_customer').submit();
      
      }

    });
    

    

    $('.page-container').click(function(e){
      $('.reg-error-email').fadeOut();
      $('.reg-error-pass').fadeOut();

    });
    
//     CUSTOMER ACCOUNT ORDER
    
    $('.prof-order').click(function(e){

      var $path = location.pathname;
      var $hash = location.hash;

      if($hash == '#customer-orders'){

      }

      $('.account-box').css("display", "none");
      $('#myorders').css("display", "block");

    });
    
//     EDIT ADDRESS BUTTON SHOW
    
    $('.address-edit-toggle').click(function(e){
      var $this = $(this),
          $formOwner = $this.data("form-id"),
          $formHolder = $this.closest('.grid__item'),
          $formid = $formHolder.find('.address-form');
      
      var $formSelect = $formid;
      $.each($formSelect, function(i, e){   
      	var $thiss = $(e),
            thisId = $thiss.data("add-id"),
            $selected = $formOwner;
        
        if( $selected == thisId ){
      		$thiss.show();
          $('.address-container').hide();
          $('.address_footer-section').hide();
          $('.address_header').hide();
        } else{
        	$this.hide();
        }
      });   
      

    });
    
//     ADD ADDRESS BUTTON

    $('#AddressNewButton').click(function(e){
      $('.address-container').hide();
      $('.address_footer-section').hide();
      $('.address_header').hide();
      $('#AddressNewForm').show();
    });
    
//     FOOTER FAQ
    
    $('.paragraph-trigger').click(function(e){
    	e.preventDefault();
      var $this = $(this);
      $this.siblings('.paragraph-content').fadeToggle();
 
    })

    
   
    $('#notice-cookie-block .button').click(function(e){
      $('#notice-cookie-block').fadeOut();
      createCookie('cookieopted', '1', 1);
    });
    

    

    function createCookie(name, value, days) {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
      }
      else var expires = "";
      document.cookie = name + "=" + value + expires + "; path=/;domain=" + document.domain + "";
    }


    function processCookieLaw(cookieLawData) {
      if (isValueValid(cookieLawData)) { $('#cookiebar').hide(); } else { $('#cookiebar').show(); }
    }

    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    }

    //   COOKIES FOR EMAIL POP-UP

    var optedIn = getCookie('cookieopted');  
    if (optedIn == null ) {
      setTimeout(function(){
        $("#notice-cookie-block").show();
        $('.newsletter-popup').show();
      },2000);
    }
    
    
    
    $('.search-view-item').hover(function(){
      var $this = $(this),
          mainFirstImage = $this.find('.collection-img').children('.col-image1').prop('src'),
          mainSecondImage = $this.find('.collection-img').children('.col-image2').prop('src');


    }, function(){
      var $this = $(this),
          mainFirtOrigImageData = $this.find('.collection-img').children('.col-image1').attr('data-originalsrc'),
          mainSecondOrigImageData = $this.find('.collection-img').children('.col-image2').attr('data-originalsrc'),
          mainFirtOrigImageWrap = $this.find('.collection-img').children('.col-image1'),
          mainSecondOrigImageWrap = $this.find('.collection-img').children('.col-image2');

      mainFirtOrigImageWrap.attr('src', mainFirtOrigImageData);
      mainSecondOrigImageWrap.attr('src', mainSecondOrigImageData);
      
     



    });

    //     COLLECTION CHANGE IMAGE ON HOVER


    jQ('.search-selection-block').hover(function(){
      var $this = $(this),
          itemFirstImage = $this.find('.selection-block-color').data('imagefirst'),
          itemSecondImage = $this.find('.selection-block-color').data('imagesecond'),
          newImageWrap1 = $this.closest('.collection-information').closest('.collection-view-item').find('.collection-img').children('.col-image1'),
          newImageWrap2 = $this.closest('.collection-information').closest('.collection-view-item').find('.collection-img').children('.col-image2');

      newImageWrap1.prop('src',itemFirstImage);
      newImageWrap2.prop('src',itemSecondImage);

    });







//     $('.cart__remove-edit').click(function(e){
//       e.preventDefault();

      
//       var $this = $(this);
//       var $editCartName = $this.attr('data-handle'),
//           $editCartQuantity = $this.attr('data-val'),
//           $editCartId = $this.attr('data-lineid');
          
      
//       $.ajax({
//         method: 'POST',
//         url: '#',
//         data: {
//           quantity: $editCartQuantity,
//           id: $editCartId,
//           name: $editCartName
          
//         },
//          success: function(data){
//       console.log(data)
                
//         },
//       });
 
//     });

    
 

  })
})(jQuery)